module.exports = __webpack_public_path__ + "static/media/RP-65.66c7d4c7.pdf";